var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckCircleOutlined = function SvgCheckCircleOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 5.333C17.28 5.333 5.334 17.28 5.334 32 5.334 46.72 17.28 58.667 32 58.667S58.667 46.72 58.667 32C58.667 17.28 46.72 5.333 32 5.333Zm0 48c-11.76 0-21.333-9.573-21.333-21.333 0-11.76 9.573-21.333 21.333-21.333 11.76 0 21.334 9.573 21.334 21.333 0 11.76-9.574 21.333-21.334 21.333Zm12.24-33.12L26.667 37.787l-6.907-6.88-3.76 3.76 10.667 10.666L48 24l-3.76-3.787Z",
    fill: "#2E7D32"
  })));
};
export default SvgCheckCircleOutlined;